import Axios from "../../../axios/axios";
import {
  Container,
  Tabs,
  Tab,
  Form,
  Row,
  Col,
  Button,
  Spinner,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { dateFormatting } from "../../utils/Utils";
import imageCompression from "browser-image-compression";

function StockTabView() {
  const { id } = useParams();
  console.log(id);
  const [stockData, setStockData] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    photo1: null,
    photo2: null,
    billUpload: null,
    purchaseCost: "",
    purchaseDate: "",
    warranty: "",
    warrantyExpiryDate: "",
    services: [],
  });

  console.log(formData);

  useEffect(() => {
    if (id) fetchStockData();
  }, [id]);
  useEffect(() => {
    getLogs();
  }, []);

  // const fetchStockData = async () => {
  //   try {
  //     console.log(id, "indis");
  //     const response = await Axios.get("/api/products/stockdata", {
  //       params: { itemCode: id },
  //     });
  //     console.log(response.data)

  //     setStockData(response.data);

  //     const s = response.data?.stock || {};
  //     setFormData({
  //       purchaseDate: new Date(s.purchaseDate).toISOString().substring(0, 10),
  //       purchaseCost: s.purchaseCost || "",
  //       warranty: s.warranty ? "true" : "false",
  //       warrantyExpiryDate: s.warrantyExpiryDate
  //         ? new Date(s.warrantyExpiryDate).toISOString().substring(0, 10)
  //         : "",
  //     });
  //   } catch (error) {
  //     console.error("Error fetching stock data:", error);
  //   }
  // };

  const fetchStockData = async () => {
    try {
      const response = await Axios.get("/api/products/stockdata", {
        params: { itemCode: id },
      });

      const stock = response.data?.stock || {};

      // ✅ Add default note: "" if missing
      const updatedServices = (stock.services || []).map((service) => ({
        ...service,
        note: service.note || "",
      }));

      setFormData({
        purchaseDate: new Date(stock.purchaseDate)
          .toISOString()
          .substring(0, 10),
        purchaseCost: stock.purchaseCost || "",
        warranty: stock.warranty ? "true" : "false",
        warrantyExpiryDate: stock.warrantyExpiryDate
          ? new Date(stock.warrantyExpiryDate).toISOString().substring(0, 10)
          : "",
        photo1: stock.photo1 || "",
        photo2: stock.photo2 || "",
        billUpload: stock.billUpload || "",
        services: updatedServices, // ✅ include updated services here
      });

      setStockData(response.data);
    } catch (error) {
      console.error("Error fetching stock data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [logs, setLogs] = useState([]);
  const getLogs = async () => {
    const { data } = await Axios.get(
      `/api/log/itemcodelogs?itemCode=${encodeURIComponent(id)}`,
    );
    const sortedLogs = data?.data?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    );
    setLogs(sortedLogs);
  };

  const [loading, setLoading] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!id) {
      console.error("ItemCode is missing");
      return;
    }

    try {
      const response = await Axios.put(
        `/api/products/stockitemCodeupdate/${encodeURIComponent(id)}`,
        {
          photo1: formData.photo1,
          photo2: formData.photo2,
          billUpload: formData.billUpload,
          purchaseCost: formData.purchaseCost,
          purchaseDate: formData.purchaseDate,
          warranty: formData.warranty,
          warrantyExpiryDate: formData.warrantyExpiryDate,
          services: formData.services || [],
        },
      );
      setMessage("✅ Stock updated successfully!");

      console.log("Stock item updated successfully:", response.data);
      console.log("Submitting formData.services:", formData.services);
    } catch (error) {
      console.error(
        "Error updating stock item:",
        error.response?.data || error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (
    e,
    fieldName,
    index = null,
    isService = false,
  ) => {
    const file = e.target.files[0];
    if (!file) return;

    // Image compression options
    const options = {
      maxSizeMB: 0.2, // Compress to 1MB or less
      maxWidthOrHeight: 1024, // Max width or height
      useWebWorker: true, // Use a web worker for processing
    };

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);
      const uploadFormData = new FormData();
      uploadFormData.append("image", compressedFile);

      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // Upload the file
      const { data } = await Axios.post("/api/upload", uploadFormData, config);

      // Set the uploaded file data based on the field

      if (isService && index !== null) {
        // Update photo in services array
        setFormData((prevState) => {
          const updatedServices = [...(prevState.services || [])];
          updatedServices[index] = {
            ...updatedServices[index],
            photo: data,
          };
          return { ...prevState, services: updatedServices };
        });
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [fieldName]: data, // Assuming `fileUrl` is returned from your API
        }));
      }

      setUploading(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploading(false);
    }
  };

  const handleServiceChange = (index, field, value) => {
    const updatedServices = [...formData.services];
    updatedServices[index] = {
      ...updatedServices[index],
      [field]: value,
    };

    console.log(updatedServices);
    setFormData({ ...formData, services: updatedServices });
  };

  const addService = () => {
    setFormData((prev) => ({
      ...prev,
      services: [
        ...(prev.services || []),
        { date: "", amount: "", note: "", photo: "" },
      ],
    }));
  };
  console.log(formData);
  const filteredLogs = logs?.filter((log) => {
    const userName = String(log.user?.name || "").toLowerCase();
    const orderId = String(log.order?.orderId || "").toLowerCase();
    const itemCode = String(log.itemCode || "").toLowerCase();
    const term = searchTerm.toLowerCase();

    return (
      userName.includes(term) ||
      orderId.includes(term) ||
      itemCode.includes(term)
    );
  });

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  const currentStock = stockData?.stock || {};

  const purchaseCost = Number(currentStock.purchaseCost || 0);

  const services = currentStock.services || [];
  const totalServices = services.length;

  const totalServiceCost = services.reduce(
    (sum, s) => sum + Number(s.amount || 0),
    0,
  );

  // ✅ Ensure stockData exists before filtering
  const rentLogs = (logs || []).filter(
    (log) =>
      log.action === "ORDER RENT OUT" && log.itemCode === currentStock.itemCode,
  );

  const totalRentCount = rentLogs.length;

  // ✅ IMPORTANT FIX HERE
  const rentPrice = stockData
    ? Number(stockData.offerPrice || stockData.price || 0)
    : 0;

  const totalRevenue = totalRentCount * rentPrice;

  const profit = totalRevenue - (purchaseCost + totalServiceCost);
  return (
    <Container fluid className="py-4" style={{ backgroundColor: "white" }}>
      <h2 className="mb-4">Stock Information</h2>

      {message && (
        <div className="alert alert-success text-center">{message}</div>
      )}

      <Tabs defaultActiveKey="view" className="mb-3" fill>
        {/* Edit Tab */}

        {/* View Tab */}
        <Tab eventKey="view" title="View Stock">
          {stockData ? (
            <div className="p-3 border rounded">
              <p>
                <b>Product Name:</b> {stockData.productName}
              </p>
              <p>
                <b>Item Code:</b> {stockData.stock.itemCode}
              </p>
              <p>
                <b>Serial Number:</b> {stockData.stock.serialNumber || "—"}
              </p>

              <p>
                <b>Photo 1:</b>{" "}
                <img
                  src={stockData.stock.photo1 || "/images/select_image.png"}
                  alt="Photo 1"
                  style={{ maxWidth: "100px" }}
                />
              </p>
              <p>
                <b>Photo 2:</b>{" "}
                <img
                  src={stockData.stock.photo2 || "/images/select_image.png"}
                  alt="Photo 2"
                  style={{ maxWidth: "100px" }}
                />
              </p>
              <p>
                <b>Bill Upload:</b>{" "}
                <img
                  src={stockData.stock.billUpload || "/images/select_image.png"}
                  alt="Bill"
                  style={{ maxWidth: "100px" }}
                />
              </p>

              <p>
                <b>Purchase Date:</b>{" "}
                {new Date(stockData.stock.purchaseDate).toLocaleDateString()}
              </p>
              <p>
                <b>Purchase Cost:</b> ₹{stockData.stock.purchaseCost}
              </p>
              <p>
                <b>Warranty:</b> {stockData.stock.warranty ? "Yes" : "No"}
              </p>
              <p>
                <b>Warranty Expiry:</b>{" "}
                {new Date(
                  stockData.stock.warrantyExpiryDate,
                ).toLocaleDateString()}
              </p>

              {stockData.stock.services &&
                stockData.stock.services.length > 0 && (
                  <>
                    <h5 className="mt-4">Services</h5>
                    {stockData.stock.services.map((s, idx) => (
                      <div key={idx} className="bg-light p-2 mb-2 rounded">
                        <p>
                          <b>Date:</b> {new Date(s.date).toLocaleDateString()}
                        </p>
                        <p>
                          <b>Cost:</b> ₹{s.amount}
                        </p>
                        <p>
                          <b>Note:</b> {s.note || "—"}
                        </p>
                        <p>
                          <b>Photo:</b>{" "}
                          {s.photo ? (
                            <img
                              src={s.photo}
                              alt="Service"
                              style={{ maxWidth: "100px" }}
                            />
                          ) : (
                            "No photo"
                          )}
                        </p>
                      </div>
                    ))}
                  </>
                )}
            </div>
          ) : (
            <p className="text-muted">Loading stock data...</p>
          )}
        </Tab>

        <Tab eventKey="edit" title="Update Stock">
          <Form onSubmit={handleUpdate}>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Photo 1</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => handleFileChange(e, "photo1")}
                  />
                  <a
                    href={
                      formData?.photo1 ||
                      stockData?.stock?.photo1 ||
                      "/images/select_image.png"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={
                        formData?.photo1 ||
                        stockData?.stock?.photo1 ||
                        "/images/select_image.png"
                      }
                      alt="Photo 1"
                      className="img-fluid mt-2"
                      style={{ height: "100px" }}
                    />
                  </a>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label>Photo 2</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => handleFileChange(e, "photo2")}
                  />
                  <a
                    href={
                      formData?.photo2 ||
                      stockData?.stock?.photo2 ||
                      "/images/select_image.png"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={
                        formData?.photo2 ||
                        stockData?.stock?.photo2 ||
                        "/images/select_image.png"
                      }
                      alt="Photo 2"
                      className="img-fluid mt-2"
                      style={{ height: "100px" }}
                    />
                  </a>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label>Bill Upload</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => handleFileChange(e, "billUpload")}
                  />
                  <a
                    href={
                      formData?.billUpload ||
                      stockData?.stock?.billUpload ||
                      "/images/select_image.png"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={
                        formData?.billUpload ||
                        stockData?.stock?.billUpload ||
                        "/images/select_image.png"
                      }
                      alt="Bill Upload"
                      className="img-fluid mt-2"
                      style={{ height: "100px" }}
                    />
                  </a>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Purchase Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="purchaseDate"
                    value={formData.purchaseDate}
                    onChange={(e) =>
                      setFormData({ ...formData, purchaseDate: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Purchase Cost</Form.Label>
                  <Form.Control
                    type="number"
                    name="purchaseCost"
                    value={formData.purchaseCost}
                    onChange={(e) =>
                      setFormData({ ...formData, purchaseCost: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Warranty Available?</Form.Label>
                  <Form.Select
                    name="warranty"
                    value={formData.warranty}
                    onChange={(e) =>
                      setFormData({ ...formData, warranty: e.target.value })
                    }
                  >
                    <option value="">-- Select --</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Warranty Expiry Date</Form.Label>
              <Form.Control
                type="date"
                name="warrantyExpiryDate"
                value={formData.warrantyExpiryDate}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    warrantyExpiryDate: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              {loading ? <Spinner animation="border" size="sm" /> : "Update"}
            </Button>
          </Form>
        </Tab>

        {/* Service Tab */}
        {/* <Tab eventKey="service" title="Service">
          <Form>
            <div className="border p-3 mb-3 rounded">
              <Form.Group>
                <Form.Label>Service Date</Form.Label>
                <Form.Control type="date" />
              </Form.Group>
              <Form.Group>
                <Form.Label>Service Cost</Form.Label>
                <Form.Control type="number" />
              </Form.Group>
              <Form.Group>
                <Form.Label>Note</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
              <Form.Group>
                <Form.Label>Service Photo</Form.Label>
                <Form.Control type="file" />
                <img
                  src="/images/select_image.png"
                  alt="Service"
                  className="img-fluid mt-2"
                  style={{ height: "100px" }}
                />
              </Form.Group>
              <Button className="mt-2" variant="success">
                Save Service
              </Button>
            </div>

            <Button variant="secondary">Add Service</Button>
          </Form>
        </Tab> */}

        {/* <Tab eventKey="service" title="Service">
          <Form>
            {formData.services?.map((service, index) => (
              <div key={index} className="border p-3 mb-3 rounded">
                <Form.Group>
                  <Form.Label>Service Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={service.date}
                    onChange={(e) =>
                      handleServiceChange(index, "date", e.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Service Cost</Form.Label>
                  <Form.Control
                    type="number"
                    value={service.amount}
                    onChange={(e) =>
                      handleServiceChange(index, "amount", e.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Note</Form.Label>
                  <Form.Control
                    type="text"
                    value={service.note}
                    onChange={(e) =>
                      handleServiceChange(index, "note", e.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Service Photo</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => handleFileChange(e, "photo", index, true)}
                  />
                  <a
                    href={
                      service.photo ||
                      process.env.PUBLIC_URL + "/images/select_image.png"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={
                        service.photo ||
                        process.env.PUBLIC_URL + "/images/select_image.png"
                      }
                      alt="Service"
                      className="img-fluid mt-2"
                      style={{ height: "100px" }}
                    />
                  </a>
                </Form.Group>

                <Button
                  className="mt-2"
                  variant="success"
                  onClick={handleUpdate}
                >
                  Save Service
                </Button>
              </div>
            ))}
            <Button onClick={addService}>Add Service</Button>
          </Form>
        </Tab> */}

        <Tab eventKey="service" title="Service">
          <Form>
            {formData.services.map((service, index) => (
              <div key={index} className="border p-3 mb-3 rounded">
                <Form.Group>
                  <Form.Label>Service Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={
                      service.date
                        ? new Date(service.date).toISOString().split("T")[0]
                        : ""
                    }
                    onChange={(e) =>
                      handleServiceChange(index, "date", e.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Service Cost</Form.Label>
                  <Form.Control
                    type="number"
                    value={service.amount}
                    onChange={(e) =>
                      handleServiceChange(index, "amount", e.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Note</Form.Label>
                  <Form.Control
                    type="text"
                    value={service.note}
                    onChange={(e) =>
                      handleServiceChange(index, "note", e.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Service Photo</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => handleFileChange(e, "photo", index)}
                  />
                  <a
                    href={
                      service.photo ||
                      process.env.PUBLIC_URL + "/images/select_image.png"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={
                        service.photo ||
                        process.env.PUBLIC_URL + "/images/select_image.png"
                      }
                      alt="Service"
                      className="img-fluid mt-2"
                      style={{ height: "100px" }}
                    />
                  </a>
                </Form.Group>

                <Button
                  className="mt-2"
                  variant="success"
                  onClick={(e) => handleUpdate(e)}
                >
                  Save Service
                </Button>
              </div>
            ))}

            <Button variant="primary" onClick={addService}>
              Add Service
            </Button>
          </Form>
        </Tab>
        {/* Logs Tab */}
        <Tab eventKey="logs" title="Logs">
          <div
            className="mt-3"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Order Number or User Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {logs && logs.length > 0 ? (
              <div className="list-group">
                {filteredLogs.map((log, idx) => (
                  <div
                    key={idx}
                    className="list-group-item list-group-item-action mb-2 border rounded"
                  >
                    {/* User Info */}
                    <div className="d-flex align-items-center mb-2">
                      <img
                        src={log.user?.photo || "/images/default-user.png"}
                        alt="User"
                        className="rounded-circle me-2"
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                        }}
                      />
                      <div>
                        <h6 className="mb-0 text-primary">
                          {log.user?.name || "Unknown User"}
                        </h6>

                        <small className="text-muted">
                          {dateFormatting(log.createdAt)}
                        </small>
                      </div>
                    </div>

                    {/* Action */}
                    <p className="mb-1">
                      <strong>Action:</strong> {log.action}
                    </p>

                    {/* Order Duration */}
                    {log.action === "ORDER PLACED" && (
                      <p className="mb-1">
                        <strong>Duration:</strong>{" "}
                        {dateFormatting(log.startDate)} →{" "}
                        {dateFormatting(log.endDate)}
                      </p>
                    )}

                    {/* Address */}
                    {log.user?.address1 && (
                      <p className="mb-1 text-muted">
                        <strong>Address:</strong> {log.user?.address1}
                      </p>
                    )}

                    {/* Product */}
                    {log.product && (
                      <p className="mb-1">
                        <strong>Product:</strong>{" "}
                        {log.product?.name || log.product}
                      </p>
                    )}
                    {log.itemCode && (
                      <p className="mb-1">
                        <strong>Item Code:</strong> {log.itemCode}
                      </p>
                    )}

                    {/* Order */}
                    {/* Order */}
                    {log.order ? (
                      <p className="mb-1">
                        <strong>Order Number:</strong>{" "}
                        {log.order.orderId ||
                          log.order.orderNumber ||
                          log.order._id}
                      </p>
                    ) : (
                      <p className="mb-1 text-muted"></p>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted">No logs found</p>
            )}
          </div>
        </Tab>
        <Tab eventKey="report" title="Stock Report">
          <div>
            <h5 className="mb-3">Stock Report</h5>

            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Purchase Cost</th>
                    <th>No. of Services</th>
                    <th>Service Cost</th>
                    <th>Rentout Count</th>
                    <th>Revenue</th>
                    <th>Profit</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>₹{purchaseCost}</td>
                    <td>{totalServices}</td>
                    <td>₹{totalServiceCost}</td>
                    <td>{totalRentCount}</td>
                    <td>₹{totalRevenue}</td>
                    <td
                      className={
                        profit >= 0
                          ? "text-success fw-bold"
                          : "text-danger fw-bold"
                      }
                    >
                      ₹{profit}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Tab>
      </Tabs>
    </Container>
  );
}

export default StockTabView;
